import { usePageId } from 'src/hooks/usePageId';

import { PageId, routing } from '../constants/routing.constant';

export const useIsWelcomePage = () => {
  const pageId = usePageId();
  return pageId === PageId.Welcome || window.location.pathname === routing[PageId.Welcome];
};
